export const ALLOWED_COUNTRIES = new Map([
  ["ALB", "Albania"],
  ["ARE", "United Arab Emirates"],
  ["ARM", "Armenia"],
  ["AUS", "Australia"],
  ["AUT", "Austria"],
  ["AZE", "Azerbaijan"],
  ["BEL", "Belgium"],
  ["BGR", "Bulgaria"],
  ["BIH", "Bosnia and Herzegovina"],
  ["BLR", "Belarus"],
  ["BRA", "Brazil"],
  ["CAN", "Canada"],
  ["CHE", "Switzerland"],
  ["COL", "Colombia"],
  ["CYP", "Cyprus"],
  ["CZE", "Czech Republic"],
  ["DEU", "Germany"],
  ["DNK", "Denmark"],
  ["DOM", "Dominican Republic"],
  ["DZA", "Algeria"],
  ["EGY", "Egypt"],
  ["ESP", "Spain"],
  ["EST", "Estonia"],
  ["FIN", "Finland"],
  ["FRA", "France"],
  ["GBR", "United Kingdom"],
  ["GEO", "Georgia"],
  ["GRC", "Greece"],
  ["HKG", "Hong Kong"],
  ["HRV", "Croatia"],
  ["HUN", "Hungary"],
  ["IND", "India"],
  ["IRL", "Ireland"],
  ["IRN", "Iran"],
  ["IRQ", "Iraq"],
  ["ISL", "Iceland"],
  ["ISR", "Israel"],
  ["ITA", "Italy"],
  ["JOR", "Jordan"],
  ["JPN", "Japan"],
  ["KAZ", "Kazakhstan"],
  ["KGZ", "Kyrgyzstan"],
  ["KOR", "South Korea"],
  ["KWT", "Kuwait"],
  ["LBN", "Lebanon"],
  ["LBY", "Libya"],
  ["LIE", "Liechtenstein"],
  ["LTU", "Lithuania"],
  ["LUX", "Luxembourg"],
  ["LVA", "Latvia"],
  ["MDA", "Moldova"],
  ["MEX", "Mexico"],
  ["MLT", "Malta"],
  ["MNE", "Montenegro"],
  ["NLD", "Netherlands"],
  ["NOR", "Norway"],
  ["POL", "Poland"],
  ["PRT", "Portugal"],
  ["QAT", "Qatar"],
  ["ROU", "Romania"],
  ["RUS", "Russia"],
  ["SGP", "Singapore"],
  ["SRB", "Serbia"],
  ["SVK", "Slovakia"],
  ["SVN", "Slovenia"],
  ["SWE", "Sweden"],
  ["THA", "Thailand"],
  ["TUN", "Tunisia"],
  ["TUR", "Turkey"],
  ["UGA", "Uganda"],
  ["UKR", "Ukraine"],
  ["USA", "United States"],
  ["UZB", "Uzbekistan"],
  ["VNM", "Vietnam"],
]);
